import moment from 'moment';
import {DateTimeInterface} from "../Interfaces/DateTimeInterface";

export function convertDateTime(datetime: DateTimeInterface|null) {
    if (datetime === null) {
        return '';
    }

    return moment(datetime.date).format('DD-MM-YY hh:mm');
}